/**
 * cb-configurator — 3-staps pakketconfigurator (Candy Box).
 *
 * Bedient elk blok met [data-cbx]. Stap 1 zet het doelaantal, stap 2 vult het,
 * stap 3 laat zien wat erin zit en schrijft het mandje weg.
 *
 * MANDJE (sinds 2026-09-07): uitsluitend de ECHTE smaken, met hun echte
 * variant, SKU en prijs. Daarna zet dit script de KORTINGSCODE van de gekozen
 * trede op het mandje (POST /cart/update.js { discount }). Die codes bestaan
 * alleen voor de landingspagina's; buiten de pagina geldt er niets. Shopify
 * rekent de korting zelf uit in mandje en checkout. Er is geen wrapper en geen
 * EUR 0,00-regel, dus er valt niets weg te halen waardoor er iets gratis
 * overblijft.
 *
 * Twee kortingsvormen per trede (data-pct / data-free op de tegel):
 *   staffel  pct > 0            korting = floor(stukprijs x pct) x aantal
 *                               (zo rondt Shopify af, gemeten 2026-09-07)
 *   x+x      pct 0, free > 0    "koop X, krijg Y gratis": Shopify maakt de Y
 *                               GOEDKOOPSTE stuks gratis (gemeten)
 *   vast     data-cbx-unit-price > 0: elke bak telt voor hetzelfde bedrag (de
 *                               kaart draagt de tweeling van de smaak). x+x:
 *                               prijs = betaalde stuks x unit_price, en de
 *                               LAATST gekozen stuks zijn de gratis vakjes.
 *                               staffel: prijs = aantal x (unit_price minus
 *                               de korting per stuk, naar beneden afgerond).
 *   bedrag   data-amt > 0 (alleen vast): vast bedrag per stuk eraf, dus prijs
 *                               = aantal x (unit_price - bedrag), exact rond;
 *                               data-pct is dan alleen tekst (afgerond).
 *
 * Bonus (sinds 2026-09-09): draagt het blok data-cbx-bonus-vid (een gratis
 * extra artikel, bv. de 400g Best Of Haribo-bak) en heeft de trede data-bonus=1,
 * dan gaat dat artikel (aantal 1, property `_aov_bonus`) mee in het mandje,
 * staat het als "gratis" in overzicht, hint en sticky balk, en telt zijn
 * winkelprijs mee in de doorgestreepte waarde. Gratis maken doet de code in de
 * admin ("krijg gratis" op silo's + dit artikel); de lade haalt het weg zodra
 * het aantal silo's onder de trede zakt.
 *
 * Drie smaken overzicht:
 *   summary: 'list'     — regels met pakshot, naam en aantal
 *   summary: 'brackets' — vakjes: één vakje per stuk, de laatste `gratis`
 *                         vakjes roze; daarin staan de goedkoopste stuks.
 *   summary: 'carousel' — horizontale kaartjes met wegknop, 1-op-1 stap 3 op
 *                         /products/viral-mousse-cakes.
 */
(function () {
  'use strict';

  function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  // Codefamilies. Een pagina ruimt alleen de codes van zijn EIGEN familie op
  // voordat hij de nieuwe zet (zodat er nooit twee tredes van dezelfde familie
  // op het mandje staan): candybekers = PAKKET-x / xPLUSyGRATIS, Haribo-silo's
  // = SILO-x / SILOxPLUSy. Een code van de andere familie blijft staan; de
  // winkelwagenlade bewaakt elke familie apart (sinds 2026-09-08).
  var CODE_FAMILIES = [/^(PAKKET-\d+|\d+PLUS\d+GRATIS)$/i, /^(SILO-\d+|SILO\d+PLUS\d+)$/i];

  function init(root) {
    if (root.__cbxInit) return;
    root.__cbxInit = true;

    var tiers = [].slice.call(root.querySelectorAll('[data-cbx-tier]'));
    var cards = [].slice.call(root.querySelectorAll('[data-cbx-flavor]'));
    var sumEl = root.querySelector('[data-cbx-summary]');
    var progEl = root.querySelector('[data-cbx-progress]');
    var hintEl = root.querySelector('[data-cbx-hint]');
    var errEl = root.querySelector('[data-cbx-error]');
    var ctaBtn = root.querySelector('[data-cbx-submit]');
    var ctaLbl = root.querySelector('[data-cbx-cta-label]');
    var railEl = root.querySelector('[data-cbx-flavors]');
    var swipeEl = root.querySelector('[data-cbx-swipe]');
    var totalEl = root.querySelector('[data-cbx-total]');
    var totalPrice = root.querySelector('[data-cbx-total-price]');
    var totalCompare = root.querySelector('[data-cbx-total-compare]');
    var totalSave = root.querySelector('[data-cbx-total-savings]');
    var unit = root.getAttribute('data-cbx-unit') || 'bak';
    var unitPl = root.getAttribute('data-cbx-unit-pl') || 'bakken';
    var sumStyle = root.getAttribute('data-cbx-summary-style') || 'list';
    var avgUnit = parseInt(root.getAttribute('data-cbx-avg'), 10) || 0;
    var minUnit = parseInt(root.getAttribute('data-cbx-min'), 10) || 0;
    var unitPrice = parseInt(root.getAttribute('data-cbx-unit-price'), 10) || 0;
    var flat = unitPrice > 0;
    var bonusVid = root.getAttribute('data-cbx-bonus-vid') || '';
    var bonusPrice = parseInt(root.getAttribute('data-cbx-bonus-price'), 10) || 0;
    var bonusTitle = root.getAttribute('data-cbx-bonus-title') || '';
    var bonusImg = root.getAttribute('data-cbx-bonus-img') || '';
    var eigenCodes = tiers.map(function (t) { return (t.getAttribute('data-code') || '').toUpperCase(); });
    var eigenFamilie = null;
    CODE_FAMILIES.forEach(function (re) {
      if (eigenFamilie) return;
      for (var i = 0; i < eigenCodes.length; i++) { if (re.test(eigenCodes[i])) { eigenFamilie = re; break; } }
    });

    // De sticky balk hoort bij dit blok maar staat er in de DOM naast.
    var sticky = root.parentNode.querySelector('[data-cbx-sticky]')
      || document.querySelector('[data-cbx-sticky]');
    var stickySum     = sticky && sticky.querySelector('[data-cbx-sticky-summary]');
    var stickyWrap    = sticky && sticky.querySelector('.cbx-sticky__overview-wrap');
    var stickyCount   = sticky && sticky.querySelector('[data-cbx-sticky-count]');
    var stickyCompare = sticky && sticky.querySelector('[data-cbx-sticky-compare]');
    var stickySave    = sticky && sticky.querySelector('[data-cbx-sticky-savings]');
    var stickyPrice   = sticky && sticky.querySelector('[data-cbx-sticky-price]');
    var stickyNote    = sticky && sticky.querySelector('[data-cbx-sticky-note]');
    var stickyLabel   = sticky && sticky.querySelector('[data-cbx-sticky-label]');
    var stickyBtn     = sticky && sticky.querySelector('[data-cbx-sticky-btn]');
    var panel         = sticky && sticky.querySelector('[data-cbx-panel]');
    var panelToggle   = sticky && sticky.querySelector('[data-cbx-panel-toggle]');
    var spacer        = (sticky && sticky.nextElementSibling && sticky.nextElementSibling.classList.contains('cbx-sticky-spacer'))
      ? sticky.nextElementSibling : null;

    // gekozen[vid] = aantal; volgorde bewaren we apart zodat het overzicht
    // toont in de volgorde waarin de klant klikte.
    var gekozen = {};
    var volgorde = [];

    function tier() {
      return root.querySelector('.cbx-tier.is-active') || tiers[0];
    }
    function attr(el, naam) { return el ? parseInt(el.getAttribute(naam), 10) || 0 : 0; }
    function doel()   { return attr(tier(), 'data-count'); }
    function gratis() { return attr(tier(), 'data-free'); }
    function pct()    { return attr(tier(), 'data-pct'); }
    function amt()    { return attr(tier(), 'data-amt'); }
    function code()   { var t = tier(); return t ? (t.getAttribute('data-code') || '') : ''; }
    function isXX()   { return gratis() > 0 && pct() === 0; }
    /* Gewone trede zonder korting (decoy): niets gratis, geen percentage, geen bedrag. */
    function isPlain() { return gratis() === 0 && pct() === 0 && amt() === 0; }
    /* Gratis extra artikel bij deze trede (zie kop). */
    function bonus() { return !!bonusVid && attr(tier(), 'data-bonus') > 0; }

    function totaalGekozen() {
      var n = 0;
      for (var k in gekozen) n += gekozen[k];
      return n;
    }

    function cardVoor(vid) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-vid') === vid) return cards[i];
      }
      return null;
    }
    function prijsVan(vid) { return attr(cardVoor(vid), 'data-price'); }

    /* Alle gekozen stuks als losse eenheden, in keuzevolgorde. */
    function eenheden() {
      return volgorde.map(function (vid, i) { return { vid: vid, i: i, prijs: prijsVan(vid) }; });
    }

    /* x+x: welke stuks zijn gratis? Shopify maakt de GOEDKOOPSTE stuks gratis,
       maar pas de stuks boven het betaalde aantal: bij 5 + 3 met 6 gekozen is
       er 1 gratis, bij 7 zijn er 2, bij 8 zijn er 3. Geeft de indexen (in
       keuzevolgorde) van de gratis stuks. */
    function gratisIndexen() {
      var gr = gratis(), betaald = doel() - gr, n = volgorde.length;
      var aantal = Math.max(0, Math.min(gr, n - betaald));
      if (!aantal) return [];
      if (flat) {
        // Alle stuks kosten hetzelfde, dus de laatst gekozen stuks zijn de gratis vakjes.
        var laatste = [];
        for (var k = n - aantal; k < n; k++) laatste.push(k);
        return laatste;
      }
      var op = eenheden().slice().sort(function (a, b) { return a.prijs - b.prijs || a.i - b.i; });
      return op.slice(0, aantal).map(function (u) { return u.i; });
    }

    /* Bedragen zoals Shopify ze uitrekent (gemeten 2026-09-07).
       Staffel: korting per STUK naar beneden afgerond, maal het aantal.
       x+x: de goedkoopste gratis stuks op nul. */
    function bedragen() {
      var som = 0, korting = 0;
      if (isXX()) {
        var u = eenheden(), vrij = {};
        gratisIndexen().forEach(function (i) { vrij[i] = 1; });
        u.forEach(function (e) { som += e.prijs; if (vrij[e.i]) korting += e.prijs; });
      } else {
        var p = pct(), a = amt();
        Object.keys(gekozen).forEach(function (vid) {
          var stuk = prijsVan(vid), n = gekozen[vid];
          som += stuk * n;
          korting += (a > 0 ? a : Math.floor(stuk * p / 100)) * n;
        });
      }
      if (bonus()) { som += bonusPrice; korting += bonusPrice; }
      return { som: som, korting: korting, betaal: som - korting };
    }

    /* Meer gekozen dan de nieuwe trede toelaat: van achteren naar voren
       afpellen, zodat de eerst gekozen smaken blijven staan. */
    function knipBij() {
      var over = totaalGekozen() - doel();
      while (over > 0 && volgorde.length) {
        var vid = volgorde[volgorde.length - 1];
        gekozen[vid] -= 1;
        if (gekozen[vid] <= 0) { delete gekozen[vid]; }
        volgorde.pop();
        over--;
      }
    }

    function zetAantal(card, delta) {
      var vid = card.getAttribute('data-vid');
      if (!vid || card.getAttribute('data-out') === '1') return;
      var max = parseInt(card.getAttribute('data-max'), 10) || 99;
      var nu = gekozen[vid] || 0;

      if (delta > 0) {
        if (totaalGekozen() >= doel()) { schud(card); return; }
        if (nu >= max) { toonVoorraad(card, max); schud(card); return; }
        gekozen[vid] = nu + 1;
        volgorde.push(vid);
      } else {
        if (nu <= 0) return;
        gekozen[vid] = nu - 1;
        if (gekozen[vid] <= 0) delete gekozen[vid];
        var i = volgorde.lastIndexOf(vid);
        if (i !== -1) volgorde.splice(i, 1);
      }
      teken();
    }

    /* Eén stuk weghalen vanaf plek `i` in de keuzevolgorde (carrousel/vakjes). */
    function haalWegIndex(i) {
      var vid = volgorde[i];
      if (!vid) return;
      volgorde.splice(i, 1);
      gekozen[vid] -= 1;
      if (gekozen[vid] <= 0) delete gekozen[vid];
      teken();
    }

    function schud(el) {
      el.classList.remove('cbx-fl--shake');
      void el.offsetWidth;
      el.classList.add('cbx-fl--shake');
    }
    function toonVoorraad(card, max) {
      var l = card.querySelector('[data-cbx-stockline]');
      if (l) l.textContent = 'Nog maar ' + max + ' op voorraad';
    }

    function tekenKaarten() {
      cards.forEach(function (c) {
        var vid = c.getAttribute('data-vid');
        var n = gekozen[vid] || 0;
        var num = c.querySelector('[data-cbx-num]');
        if (num) num.textContent = n;
        c.classList.toggle('is-picked', n > 0);
        var max = parseInt(c.getAttribute('data-max'), 10) || 99;
        var l = c.querySelector('[data-cbx-stockline]');
        if (l && n < max) l.textContent = '';
      });
    }

    function kaartInfo(vid) {
      var c = cardVoor(vid);
      if (!c) return null;
      var t = c.getAttribute('data-title');
      var w = c.getAttribute('data-weight');
      return { vid: vid, img: c.getAttribute('data-img'), t: t, w: w, tw: w ? t + ' · ' + w : t };
    }

    function slotHtml(v, isGratis, compact) {
      var cls = 'cbx-slot' + (isGratis ? ' cbx-slot--free' : '') + (v ? ' is-filled' : '');
      if (!v) {
        return '<span class="' + cls + '">' + (isGratis ? '<span class="cbx-slot__word">Gratis</span>' : '') + '</span>';
      }
      return '<span class="' + cls + '" title="' + esc(v.tw) + '">'
        + '<img src="' + esc(v.img) + '" alt="' + esc(v.tw) + '">'
        + (isGratis ? '<span class="cbx-slot__tag">Gratis</span>' : '')
        + (compact ? '' : '<button type="button" class="cbx-slot__del" data-cbx-ovw-del="'
            + v.i + '" aria-label="' + esc(v.t) + ' weghalen">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>')
        + '</span>';
    }

    /* Vakjes: `tot` vakjes, de laatste `gratis` roze. De betaalde vakjes
       vullen zich in keuzevolgorde; in de roze vakjes staan de goedkoopste
       stuks, want die maakt Shopify gratis. */
    function slotsHtml(compact) {
      var tot = doel(), gr = gratis(), betaald = tot - gr;
      var vrij = {};
      gratisIndexen().forEach(function (i) { vrij[i] = 1; });
      var betaaldLijst = [], gratisLijst = [];
      volgorde.forEach(function (vid, i) {
        var k = kaartInfo(vid);
        if (!k) return;
        k.i = i;
        (vrij[i] ? gratisLijst : betaaldLijst).push(k);
      });
      var out = '';
      for (var a = 0; a < betaald; a++) out += slotHtml(betaaldLijst[a], false, compact);
      for (var b = 0; b < gr; b++) out += slotHtml(gratisLijst[b], true, compact);
      if (bonus()) out += bonusSlotHtml();
      return out;
    }
    function bonusSlotHtml() {
      return '<span class="cbx-slot cbx-slot--free cbx-slot--bonus is-filled" title="' + esc(bonusTitle) + ' \u00b7 gratis">'
        + (bonusImg ? '<img src="' + esc(bonusImg) + '" alt="' + esc(bonusTitle) + '">' : '')
        + '<span class="cbx-slot__tag">Gratis</span></span>';
    }
    function bonusItemHtml() {
      return '<div class="cbx-ovw__item is-free cbx-ovw__item--bonus">'
        + (bonusImg ? '<img src="' + esc(bonusImg) + '" alt="">' : '')
        + '<span class="cbx-ovw__free">Gratis</span>'
        + '<span class="cbx-ovw__name">' + esc(bonusTitle) + '</span></div>';
    }
    function bonusLineHtml() {
      return '<div class="cbx-line cbx-line--bonus">'
        + (bonusImg ? '<img src="' + esc(bonusImg) + '" alt="">' : '<span class="cbx-line__ph"></span>')
        + '<span class="cbx-line__t">' + esc(bonusTitle) + '</span>'
        + '<span class="cbx-line__n">Gratis</span></div>';
    }

    /* Carrousel: één kaartje per gekozen stuk, met pakshot, naam en kruisje. */
    function carouselHtml() {
      var out = '';
      var vrij = {};
      if (isXX()) gratisIndexen().forEach(function (i) { vrij[i] = 1; });
      volgorde.forEach(function (vid, i) {
        var k = kaartInfo(vid);
        if (!k) return;
        out += '<div class="cbx-ovw__item' + (vrij[i] ? ' is-free' : '') + '">'
          + '<img src="' + esc(k.img) + '" alt="">'
          + (vrij[i] ? '<span class="cbx-ovw__free">Gratis</span>' : '')
          + '<span class="cbx-ovw__name">' + esc(k.t) + (k.w ? '<small>' + esc(k.w) + '</small>' : '') + '</span>'
          + '<button type="button" class="cbx-ovw__remove" data-cbx-ovw-del="' + i + '"'
          + ' aria-label="' + esc(k.t) + ' weghalen">'
          + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">'
          + '<line x1="2" y1="2" x2="10" y2="10"/><line x1="10" y1="2" x2="2" y2="10"/>'
          + '</svg></button></div>';
      });
      if (bonus()) out += bonusItemHtml();
      return out ? '<div class="cbx-ovw">' + out + '</div>' : '';
    }

    function overzichtHtml() {
      if (sumStyle === 'brackets') return '<div class="cbx-slots">' + slotsHtml(false) + '</div>';
      if (sumStyle === 'carousel') return carouselHtml();
      return lijstHtml();
    }

    function lijstHtml() {
      var out = '';
      var gezien = {};
      volgorde.forEach(function (vid) {
        if (gezien[vid]) return;
        gezien[vid] = 1;
        var k = kaartInfo(vid);
        if (!k) return;
        out += '<div class="cbx-line"><img src="' + esc(k.img) + '" alt="">'
          + '<span class="cbx-line__t">' + esc(k.tw) + '</span>'
          + '<span class="cbx-line__n">' + gekozen[vid] + '×</span></div>';
      });
      var leeg = doel() - totaalGekozen();
      for (var i = 0; i < leeg; i++) {
        out += '<div class="cbx-line cbx-line--empty"><span class="cbx-line__ph"></span>'
          + '<span class="cbx-line__t">Nog te kiezen</span></div>';
      }
      if (bonus()) out += bonusLineHtml();
      return out;
    }

    /* Het overzicht in de balk meeschuiven naar het laatst toegevoegde stuk. */
    function railNaarLaatste() {
      if (!stickyWrap) return;
      var kinderen = stickyWrap.querySelectorAll('.cbx-ovw__item, .cbx-slot.is-filled');
      if (!kinderen.length) { stickyWrap.scrollLeft = 0; return; }
      var laatste = kinderen[kinderen.length - 1];
      var doelX = laatste.offsetLeft + laatste.offsetWidth - stickyWrap.clientWidth + 8;
      stickyWrap.scrollLeft = Math.max(0, doelX);
    }

    function teken() {
      var tot = doel(), n = totaalGekozen(), gr = gratis(), p = pct(), xx = isXX(), a = amt();
      var b = bedragen();
      var klaar = n >= tot;

      if (sumEl) sumEl.innerHTML = overzichtHtml();

      if (progEl) {
        progEl.innerHTML = klaar
          ? '<b>' + tot + ' van ' + tot + '</b> gekozen — je pakket is compleet'
          : '<b>' + n + ' van ' + tot + '</b> gekozen — nog ' + (tot - n) + ' te gaan';
        progEl.classList.toggle('is-done', klaar);
      }
      if (hintEl) {
        if (isPlain()) {
          hintEl.innerHTML = 'Kies ' + tot + ' ' + unitPl + (flat ? ' \u00e0 ' + euro(unitPrice) : '') + '. Meerdere van dezelfde smaak mag.';
        } else if (xx && flat) {
          hintEl.innerHTML = 'Kies ' + tot + ' ' + unitPl + ' à ' + euro(unitPrice) + '. Je betaalt er ' + (tot - gr) + ', <b>'
            + (gr === 1 ? 'de laatste is gratis' : gr + ' zijn gratis') + '</b>'
            + (bonus() ? ', en je krijgt er een <b>' + esc(bonusTitle) + ' gratis</b> bij' : '') + '. Meerdere van dezelfde smaak mag.';
        } else if (xx) {
          hintEl.innerHTML = 'Kies ' + tot + ' ' + unitPl + '. Je betaalt er ' + (tot - gr) + ', '
            + (gr === 1 ? 'de <b>goedkoopste is gratis</b>' : 'de <b>' + gr + ' goedkoopste zijn gratis</b>')
            + '. Meerdere van dezelfde smaak mag.';
        } else if (gr > 0) {
          hintEl.innerHTML = 'Kies ' + tot + ' ' + unitPl + '. Je betaalt er ' + (tot - gr) + ', <b>' + gr + ' zijn gratis</b> (' + p + '% korting op het hele pakket). Meerdere van dezelfde smaak mag.';
        } else if (flat) {
          var perStuk = a > 0 ? unitPrice - a : unitPrice - Math.floor(unitPrice * p / 100);
          hintEl.innerHTML = 'Kies ' + tot + ' ' + unitPl + ' van ' + euro(unitPrice) + ' en betaal <b>' + euro(perStuk) + ' per ' + unit
            + '</b> (' + p + '% korting). Meerdere van dezelfde smaak mag.';
        } else {
          hintEl.innerHTML = 'Kies ' + tot + ' ' + unitPl + ' en krijg <b>' + p + '% korting</b> op alle ' + tot + '. Meerdere van dezelfde smaak mag.';
        }
      }

      // Prijsregel in stap 3: pas zichtbaar zodra er iets gekozen is.
      if (totalEl) {
        totalEl.hidden = n === 0;
        if (totalPrice) totalPrice.textContent = euro(b.betaal);
        if (totalCompare) totalCompare.textContent = b.korting > 0 ? euro(b.som) : '';
        if (totalSave) {
          var pil = '';
          if (b.korting > 0) pil = (xx || a > 0) ? '-' + euro(b.korting) : '-' + p + '%';
          totalSave.textContent = pil;
          totalSave.hidden = !pil;
        }
      }

      if (ctaLbl) {
        ctaLbl.textContent = klaar
          ? 'In de winkelwagen · ' + euro(b.betaal)
          : 'Kies nog ' + (tot - n) + ' ' + (tot - n === 1 ? unit : unitPl);
      }
      if (ctaBtn) ctaBtn.classList.toggle('is-ready', klaar);

      /* ---- sticky balk: zelfde overzicht, zelfde bedragen als stap 3 ---- */
      if (stickySum) {
        stickySum.innerHTML = overzichtHtml();
        railNaarLaatste();
      }
      if (stickyCount) stickyCount.textContent = n + ' van ' + tot;
      /* Nog niets gekozen: dan staat de pakketprijs van de trede in de balk
         (vaste prijs), zodat de balk vanaf het begin iets zegt. */
      var tredePrijs = (flat && n === 0) ? tot * (a > 0 ? unitPrice - a : (xx ? 0 : unitPrice - Math.floor(unitPrice * p / 100))) : 0;
      if (xx && flat && n === 0) tredePrijs = (tot - gr) * unitPrice;
      if (stickyPrice) stickyPrice.textContent = n === 0 ? (tredePrijs ? euro(tredePrijs) : '') : euro(b.betaal);
      if (stickyCompare) stickyCompare.textContent = n === 0 ? (tredePrijs && tredePrijs < tot * unitPrice ? euro(tot * unitPrice) : '') : (b.korting > 0 ? euro(b.som) : '');
      if (panelToggle) panelToggle.hidden = n === 0;
      if (stickySave) {
        if (b.korting > 0) {
          stickySave.textContent = '-' + euro(b.korting);
          stickySave.removeAttribute('hidden');
        } else {
          stickySave.textContent = '';
          stickySave.setAttribute('hidden', '');
        }
      }
      if (stickyNote) {
        var noteTxt = (gr > 0)
          ? (xx && flat ? (gr === 1 ? '1 van je ' + tot + ' ' + unitPl + ' is gratis'
                                    : gr + ' van je ' + tot + ' ' + unitPl + ' zijn gratis')
             : xx ? (gr === 1 ? 'De goedkoopste van je ' + tot + ' ' + unitPl + ' is gratis'
                          : 'De ' + gr + ' goedkoopste van je ' + tot + ' ' + unitPl + ' zijn gratis')
                : gr + ' van de ' + tot + ' ' + unitPl + ' zijn gratis')
          : (a > 0 ? euro(unitPrice - a) + ' per ' + unit + ' in plaats van ' + euro(unitPrice)
             : p > 0 ? p + '% korting op je hele pakket' : '');
        if (bonus()) noteTxt += (noteTxt ? ' + ' : '') + 'gratis ' + bonusTitle;
        stickyNote.textContent = noteTxt;
      }
      if (stickyLabel && ctaLbl) stickyLabel.textContent = ctaLbl.textContent;
      if (stickyBtn) stickyBtn.classList.toggle('is-ready', klaar);
      zetStickyZichtbaar();

      tekenKaarten();
      if (errEl) errEl.classList.remove('is-visible');
    }

    /* De pagina (banner, kop) luistert hierop en vertelt hetzelfde verhaal als
       de gekozen trede. Ook één keer bij het laden. */
    function meldTrede() {
      var t = tier();
      if (!t) return;
      var tot = doel(), gr = gratis(), p = pct(), a = amt(), keep = 100 - p;
      // Vaste prijs: per stuk exact zoals Shopify afrondt (naar beneden); bij een
      // vast bedrag per stuk is het gewoon unit_price min dat bedrag.
      var perAfter = flat ? (a > 0 ? unitPrice - a : unitPrice - Math.floor(unitPrice * p / 100)) : Math.round(avgUnit * keep / 100);
      try {
        root.dispatchEvent(new CustomEvent('cbx:tier', {
          bubbles: true,
          detail: {
            count: tot, free: gr, paid: tot - gr, pct: p, mode: isXX() ? 'xx' : (isPlain() ? 'plain' : 'pct'),
            plain: isPlain(),
            code: code(),
            avgUnit: avgUnit,
            avgUnitAfter: perAfter,
            avgTotal: flat ? perAfter * tot : Math.round(avgUnit * tot * keep / 100),
            minTotal: isXX() ? minUnit * (tot - gr) : (flat ? perAfter * tot : Math.round(minUnit * tot * keep / 100)),
            unitPrice: flat ? unitPrice : avgUnit,
            unitAfter: perAfter,
            amt: a,
            bonus: bonus() ? bonusTitle : '',
            bonusPrice: bonus() ? bonusPrice : 0,
            note: t.getAttribute('data-note') || '',
            label: t.getAttribute('data-label')
          }
        }));
      } catch (e) {}
    }

    // ── stap 1 ──────────────────────────────────────────────────────────
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (o) {
          o.classList.toggle('is-active', o === t);
          o.setAttribute('aria-checked', o === t ? 'true' : 'false');
        });
        knipBij();
        teken();
        meldTrede();
      });
    });

    // ── stap 2 ──────────────────────────────────────────────────────────
    root.addEventListener('click', function (e) {
      var ovw = e.target.closest('[data-cbx-ovw-del]');
      if (ovw) { haalWegIndex(parseInt(ovw.getAttribute('data-cbx-ovw-del'), 10)); return; }
      var card = e.target.closest('[data-cbx-flavor]');
      if (!card) return;
      if (e.target.closest('[data-cbx-minus]')) { zetAantal(card, -1); return; }
      if (e.target.closest('[data-cbx-plus]') || e.target.closest('[data-cbx-add-flavor]')) {
        zetAantal(card, 1); return;
      }
    });

    // De veegtip verdwijnt zodra de klant daadwerkelijk geveegd heeft.
    if (railEl && swipeEl) {
      railEl.addEventListener('scroll', function () {
        if (railEl.scrollLeft > 12) swipeEl.classList.add('is-gone');
      }, { passive: true });
    }

    // Pijlen langs de rail voor wie geen touchscreen heeft.
    var railNav = [].slice.call(root.querySelectorAll('[data-cbx-rail]'));
    if (railEl && railNav.length) {
      var kaartBreedte = function () {
        var k = railEl.querySelector('.cbx-fl');
        return k ? k.getBoundingClientRect().width + 10 : 105;
      };
      var tekenRailNav = function () {
        var max = railEl.scrollWidth - railEl.clientWidth;
        railNav.forEach(function (b) {
          var richting = parseInt(b.getAttribute('data-cbx-rail'), 10);
          b.hidden = richting < 0 ? railEl.scrollLeft <= 4 : railEl.scrollLeft >= max - 4;
        });
      };
      railNav.forEach(function (b) {
        b.addEventListener('click', function () {
          var richting = parseInt(b.getAttribute('data-cbx-rail'), 10);
          railEl.scrollBy({ left: richting * kaartBreedte() * 3, behavior: 'smooth' });
        });
      });
      railEl.addEventListener('scroll', tekenRailNav, { passive: true });
      window.addEventListener('resize', tekenRailNav);
      tekenRailNav();
    }

    // ── sticky: uitklapbaar overzicht ───────────────────────────────────
    function zetPaneel(open) {
      if (!sticky) return;
      sticky.classList.toggle('is-open', !!open);
      if (panelToggle) {
        panelToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var lbl = panelToggle.querySelector('.cbx-sticky__toggle-label');
        if (lbl) lbl.textContent = open ? 'Verberg items' : 'Toon items';
      }
      if (open) railNaarLaatste();
      maakRuimte();
    }
    if (panelToggle) {
      panelToggle.addEventListener('click', function () {
        zetPaneel(!sticky.classList.contains('is-open'));
      });
    }
    if (panel) {
      panel.addEventListener('click', function (e) {
        var ovw = e.target.closest('[data-cbx-ovw-del]');
        if (ovw) haalWegIndex(parseInt(ovw.getAttribute('data-cbx-ovw-del'), 10));
      });
    }

    /* De balk staat er zolang de grote knop van stap 3 uit beeld is, dus ook
       al voordat de klant iets gekozen heeft (eigenaar 08-09: "de atc-knop al
       sticky"). Zodra stap 3 in beeld is neemt de grote knop het over. Op
       desktop houdt de CSS hem sowieso weg. Ruimte onderaan de pagina komt
       van padding op body (niet van een spacer in de sectie, die liet de
       pagina springen), zodat de laatste inhoud boven de balk uit kan. */
    var ctaInBeeld = false, pbHoogte = 0;
    function maakRuimte() {
      if (!sticky) return;
      var toont = sticky.classList.contains('is-visible') && getComputedStyle(sticky).display !== 'none';
      document.body.style.paddingBottom = toont ? (sticky.offsetHeight + pbHoogte) + 'px' : '';
    }
    function zetStickyZichtbaar() {
      if (!sticky) return;
      var aan = !ctaInBeeld;
      sticky.classList.toggle('is-visible', aan);
      sticky.setAttribute('aria-hidden', aan ? 'false' : 'true');
      if (!aan) zetPaneel(false);
      maakRuimte();
    }
    if (ctaBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        ctaInBeeld = es[0].isIntersecting;
        zetStickyZichtbaar();
      }, { threshold: 0.4 }).observe(ctaBtn);
    }
    window.addEventListener('resize', maakRuimte);

    /* Themapreview: Shopify legt een previewbalk (#PBarNextFrameWrapper, 68px)
       over de onderkant van het scherm, precies over de knop van de sticky
       balk. Dan lijkt de knop weg. Hier tillen we de balk erbovenuit; live is
       er geen previewbalk en doet dit niets. */
    function tilBovenPreviewBalk() {
      if (!sticky) return;
      var pb = document.getElementById('PBarNextFrameWrapper');
      var h = 0;
      if (pb) {
        var r = pb.getBoundingClientRect();
        if (r.height > 0 && r.height < 240 && r.bottom >= window.innerHeight - 2) h = Math.round(r.height);
      }
      sticky.style.bottom = h ? h + 'px' : '';
      pbHoogte = h;
      maakRuimte();
    }
    tilBovenPreviewBalk();
    var pbTicks = 0;
    var pbTimer = setInterval(function () {
      tilBovenPreviewBalk();
      if (++pbTicks > 20) clearInterval(pbTimer);
    }, 1000);
    window.addEventListener('resize', tilBovenPreviewBalk);

    // ── kortingscode op het mandje ──────────────────────────────────────
    function isOnzeCode(c) {
      c = String(c || '').toUpperCase();
      return (eigenFamilie && eigenFamilie.test(c)) || eigenCodes.indexOf(c) !== -1;
    }
    /* Zet de code van de gekozen trede op het mandje. Codes van andere
       pakkettredes gaan eraf, codes van de klant zelf (bv. een welkomstcode)
       blijven staan. Lukt update.js niet, dan de klassieke /discount/-route
       (zet een cookie die de checkout leest). */
    function zetCode(cd) {
      if (!cd) return Promise.resolve();
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lijst = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return !isOnzeCode(c); });
          lijst.push(cd);
          return fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ discount: lijst.join(',') }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('code-failed'); return r.json(); })
        .catch(function () {
          return fetch('/discount/' + encodeURIComponent(cd), { credentials: 'same-origin', redirect: 'follow' }).catch(function () {});
        });
    }

    // ── stap 3: naar het mandje ─────────────────────────────────────────
    function naarMandje() {
      var tot = doel(), n = totaalGekozen();
      if (n < tot) {
        if (errEl) {
          errEl.textContent = 'Kies eerst ' + tot + ' ' + unitPl + '.';
          errEl.classList.add('is-visible');
        }
        if (stickyNote) stickyNote.textContent = 'Kies eerst ' + (tot - n) + ' ' + (tot - n === 1 ? unit : unitPl) + ' hierboven.';
        zetPaneel(false);
        var fl = root.querySelector('[data-cbx-flavors]');
        if (fl) fl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var t = tier();
      var bron = root.getAttribute('data-cbx-context') || 'cb-configurator';
      var items = [];
      Object.keys(gekozen).forEach(function (vid) {
        items.push({
          id: parseInt(vid, 10),
          quantity: gekozen[vid],
          properties: {
            '_aov_pakket': t.getAttribute('data-label'),
            '_aov_bron': bron
          }
        });
      });

      if (bonus()) {
        items.push({
          id: parseInt(bonusVid, 10),
          quantity: 1,
          properties: { '_aov_pakket': t.getAttribute('data-label'), '_aov_bron': bron, '_aov_bonus': '1' }
        });
      }

      ctaBtn.classList.add('is-busy');
      if (stickyBtn) stickyBtn.classList.add('is-busy');
      // ?kaching_bundles=true = doorlaatpad in de Kaching-interceptor; Shopify negeert de parameter.
      fetch('/cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || 'add-failed'); });
          return r.json();
        })
        .then(function () { return zetCode(code()); })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble, .header-custom__cart-count')
            .forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? '' : 'none';
            });
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
          ctaBtn.classList.remove('is-busy');
          if (stickyBtn) stickyBtn.classList.remove('is-busy');
          zetPaneel(false);
          if (window.candyCartDrawer && typeof window.candyCartDrawer.open === 'function') {
            window.candyCartDrawer.open();
          } else if (typeof window.SLIDECART_OPEN === 'function') {
            window.SLIDECART_OPEN();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          ctaBtn.classList.remove('is-busy');
          if (stickyBtn) stickyBtn.classList.remove('is-busy');
          if (err && err.dealBlocked) return;
          if (errEl) {
            errEl.textContent = 'Toevoegen lukte niet. Probeer het nog een keer.';
            errEl.classList.add('is-visible');
          }
        });
    }
    if (ctaBtn) ctaBtn.addEventListener('click', naarMandje);
    if (stickyBtn) stickyBtn.addEventListener('click', naarMandje);

    teken();
    meldTrede();
  }

  function initAll() { document.querySelectorAll('[data-cbx]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  window.cbxInit = initAll;
})();
